/**
 * Type-safe обёртки каталога удобств + глобального пака иконок
 * (правки Артёма 2026-06-17). Поверх бэка internal/amenity.
 *
 * GET /v1/icons — глобальный пак (read, всем авторизованным).
 * GET/POST/PUT/DELETE /v1/amenities — per-tenant каталог; мутации гейтятся
 * на бэке (cmd/api/main.go: /v1/amenities POST/PUT/PATCH/DELETE → mgmt).
 */
import { customFetch } from './openapi-fetch.js';
import type {
  AmenitiesResponse,
  AmenityView,
  CreateAmenityInput,
  IconsResponse,
  IconView,
  UpdateAmenityInput,
} from '@hsc/types';

/** GET /v1/icons — глобальный пак иконок для пикера. */
export async function listIcons(): Promise<IconView[]> {
  const res = await customFetch<IconsResponse>({ url: '/icons', method: 'GET' });
  return res.icons ?? [];
}

/** GET /v1/amenities — каталог удобств тенанта (tenant-context по поддомену). */
export async function listAmenities(): Promise<AmenityView[]> {
  const res = await customFetch<AmenitiesResponse>({ url: '/amenities', method: 'GET' });
  return res.amenities ?? [];
}

/** POST /v1/amenities — завести своё удобство (mgmt). */
export async function createAmenity(input: CreateAmenityInput): Promise<AmenityView> {
  return customFetch<AmenityView>({ url: '/amenities', method: 'POST', data: input });
}

/** PUT /v1/amenities/{id} — изменить название/иконку/активность (mgmt). */
export async function updateAmenity(id: string, input: UpdateAmenityInput): Promise<AmenityView> {
  return customFetch<AmenityView>({
    url: `/amenities/${encodeURIComponent(id)}`,
    method: 'PUT',
    data: input,
  });
}

/** DELETE /v1/amenities/{id} — удалить удобство (mgmt). */
export async function deleteAmenity(id: string): Promise<void> {
  await customFetch<void>({ url: `/amenities/${encodeURIComponent(id)}`, method: 'DELETE' });
}
